import React, { forwardRef } from "react";
import styled from "styled-components";
import { CommonText } from "styledComponents/common";



import decreaseIcon from "../../../assets/img/icons/decrease.svg";
import increaseIcon from "../../../assets/img/icons/increase.svg";
import { SmallInfoCardSkeletonAmount, SmallInfoCardSkeletonDelta, SmallInfoCardSkeletonIcon, SmallInfoCardSkeletonSubText, SmallInfoCardSkeletonTitle } from "../../DashBoardNew/dashBoardNewStyles";


const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  padding: 12px 14px;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
    min-height: ${({ cardHeight }) => cardHeight || "auto"};
  background: #ffffff;
  border: 1px solid #d3e0fc;
  border-radius: 8px;
  box-shadow: none;
  transition: box-shadow 120ms ease;
  /* &:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #c0d0ce;
  } */

  /* @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 10px;
    max-width: 100%;
  }

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
  } */
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  min-width: 0;
  flex-wrap: wrap;
`;

const TitleText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #353A46;
  margin: 0;
`;

const ContentLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: max-content;
  flex: 1 1 0;
`;

const ContentRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
`;

const DeltaSubTextGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex-wrap: wrap;
`;

const BodyColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const AmountText = styled.div`
  height: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #000E2A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IconWithText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
`;

const IconImg = styled.img`
  width: 10px;
  height: 10px;
  display: block;
`;

const DeltaText = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: ${({ deltaType }) => (deltaType === "increase" ? "#27AE60" : "#FF5722")};
`;

const SubText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #7B8281;
`;

const SmallInfoCard = ({
  isLoading,
  iconSrc = null,
  title,
  amount,
  delta,
  deltaType, // 'increase' | 'decrease'
  subText,
  cardHeight,
}, ref) => {

  const showDelta = delta !== undefined && delta !== null;
  const icon = deltaType === "increase" ? increaseIcon : decreaseIcon;

  // Render skeleton loading state
  if (isLoading) {
    return (
      <Card ref={ref} cardHeight={cardHeight}>
        <Row>
          <SmallInfoCardSkeletonTitle />
          {iconSrc ? <SmallInfoCardSkeletonIcon /> : null}
        </Row>

        <Row>
          <ContentLeft>
            <BodyColumn>
              <SmallInfoCardSkeletonAmount />
            </BodyColumn>
          </ContentLeft>

          <ContentRight>
            <DeltaSubTextGroup>
              {showDelta ? <SmallInfoCardSkeletonDelta /> : null}
              <SmallInfoCardSkeletonSubText />
            </DeltaSubTextGroup>
          </ContentRight>
        </Row>
      </Card>
    );
  }

  return (
    <Card ref={ref} cardHeight={cardHeight}>
      <Row>
        <TitleText>{title}</TitleText>

        {iconSrc ? (
          <div style={{ flex: "0 0 auto" }}>
            <img src={iconSrc} alt="icon" style={{ width: 36, height: 36 }} />
          </div>
        ) : null}
      </Row>

      <Row>
        <ContentLeft>
          <BodyColumn>
            <AmountText>{amount}</AmountText>
          </BodyColumn>
        </ContentLeft>

        <ContentRight>
          <DeltaSubTextGroup>
            {showDelta ? (
              <IconWithText>
                <IconImg src={icon} alt={deltaType} />
                <DeltaText deltaType={deltaType}>{delta}</DeltaText>
              </IconWithText>
            ) : null}
            <SubText>{subText}</SubText>
          </DeltaSubTextGroup>
        </ContentRight>
      </Row>
    </Card>
  );
};

export default forwardRef(SmallInfoCard);